import { render, staticRenderFns } from "./viewCharges.vue?vue&type=template&id=4550bc27"
import script from "./viewCharges.ts?vue&type=script&lang=js&external"
export * from "./viewCharges.ts?vue&type=script&lang=js&external"
import style0 from "./viewCharges.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports